import React, { useCallback } from "react";
import { Form, Row, Col, Input, Modal } from "antd";
import { requestProfileChanges } from "@/services/users_new";
import AddressInput from "@/components/AddressInput";
import PhoneNumberInput from "@/components/PhoneNumberInput";
import { flatPhoneNumber } from "@/components/PhoneNumberInput/utils";

const { TextArea } = Input;

export default function UserRequestForm({ formRef, setLoading, setVisibleRequestUserChangesForm }) {
  const onFinish = useCallback(
    values => {
      setLoading(true);

      const { stateId, stateName, stateShortName, phoneNumber, ...rest } = values;
      const payload = {
        ...rest,
        phoneNumber: flatPhoneNumber(phoneNumber),
        state: {
          id: stateId,
          name: stateName,
          shortName: stateShortName,
        },
      };

      requestProfileChanges(payload)
        .then(response => {
          if (response) {
            Modal.success({
              content: `Request sent successfully. Changes will reflect after review by Autosled Operations.`,
              style: { fontWeight: "bold" },
              width: "25%",
            });
            setVisibleRequestUserChangesForm(false);
          }
        })
        .catch(err => {
          console.log(err);
          Modal.error({
            content: `Request failed to send. Please try again or contact Autosled support if this continues to happen.`,
            style: { fontWeight: "bold" },
            width: "25%",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [setLoading, setVisibleRequestUserChangesForm],
  );

  return (
    <Form form={formRef} requiredMark={false} layout="vertical" onFinish={onFinish}>
      <div>
        Please enter updated information. Changes will be applied after review by Autosled operations. Please also
        provide a brief explanation of the reason for the update.
      </div>
      <br />
      <Row gutter={16}>
        <Col lg={12}>
          <Form.Item name="firstName" label="First Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12}>
          <Form.Item name="lastName" label="Last Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col lg={24}>
          <PhoneNumberInput
            formItemProps={{
              name: "phoneNumber",
              label: "Phone Number",
              extensionName: "phoneExtension",
              formRef: formRef,
              rules: [{ required: true }],
            }}
          />
        </Col>
      </Row>
      <AddressInput formReference={{ current: formRef }} />
      <Row gutter={16}>
        <Col flex={1}>
          <Form.Item name="reason" label="Reason for Request" rules={[{ required: true }]}>
            <TextArea rows={4} />
          </Form.Item>
        </Col>
        <Form.Item name="userId" label="User Id" rules={[{ required: true }]} hidden>
          <Input />
        </Form.Item>
      </Row>
    </Form>
  );
}
